import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";
import sampleImage from "../../../Image/faq.jpg";

const newsData = [
  {
    title: "What skills are important in Supply Chain Management?",
    category: "Technology",
    description:
      "Key SCM skills include inventory management, logistics planning, forecasting, data analysis, negotiation, communication, and understanding ERP tools. Strong analytical thinking and decision-making are essential for handling real-world supply and demand challenges effectively.",
  },
  {
    title: "Which industries hire supply chain professionals?",
    category: "Trending",
    description:
      "Supply chain professionals work in manufacturing, e-commerce, retail, logistics, FMCG, healthcare, automotive, pharmaceuticals, aviation, and global trading. Any industry involving production, movement, or distribution of goods requires trained supply chain specialists.",
  },
  {
    title: "What tools and software are used in SCM?",
    category: "Design",
    description:
      "SCM uses tools like SAP, Oracle ERP, Tally, JDA, Excel, Power BI, WMS, TMS, RFID systems, and forecasting software. These tools help manage inventory, logistics, procurement, and supply chain analytics.",
  },
  {
    title: "What job roles are available in Supply Chain Management?",
    category: "Design",
    description:
      "Common SCM roles include Supply Chain Analyst, Logistics Coordinator, Procurement Specialist, Inventory Manager, Demand Planner, Warehouse Manager, Operations Executive, and Supply Chain Manager, each handling specific parts of the supply and distribution process.",
  },
  {
    title: "How does technology impact supply chain management?",
    category: "Design",
    description:
      "Technologies like automation, AI, IoT, blockchain, and robotics improve forecasting, reduce errors, track goods in real time, enhance visibility, and optimize supply chain performance across global operations.",
  },
];

const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDescription = (i) => {
    setExpandedIndex(expandedIndex === i ? null : i);
  };

  return (
    <div className="faq-wrapper">
      <motion.h2
        className="faq-heading"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        FAQ — Frequently Asked Questions
      </motion.h2>
      <div className="news-section-container">
        <motion.div
          className="news-left-image"
          initial={{ opacity: 0, rotateY: -90 }}
          whileInView={{ opacity: 1, rotateY: 0 }}
          transition={{
            duration: 0.9,
            ease: "easeOut",
            delay: 0.2,
          }}
          viewport={{ once: false, amount: 0.4 }}
        >
          <img src={sampleImage} alt="Main Preview" />
        </motion.div>

        <motion.div
          className="news-right-list"
          initial={{ opacity: 0, scale: 0.8, y: 40 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeOut",
            delay: 0.3,
          }}
          viewport={{ once: false, amount: 0.3 }}
        >
          {newsData.map((item, index) => (
            <motion.div
              key={index}
              className="news-item"
              whileHover={{ x: 10, backgroundColor: "#eefef6" }}
              transition={{ duration: 0.3 }}
              onClick={() => toggleDescription(index)}
            >
              <div className="row">
                <div className="title">{item.title}</div>

                {/* <div className="category">{item.category}</div> */}

                <motion.div
                  animate={{ rotate: expandedIndex === index ? 90 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="arrow"
                >
                  ➤
                </motion.div>
              </div>

              <AnimatePresence>
                {expandedIndex === index && (
                  <motion.div
                    className="card-description"
                    layout
                    initial={{ opacity: 0, maxHeight: 0 }}
                    animate={{ opacity: 1, maxHeight: 800 }}
                    exit={{ opacity: 0, maxHeight: 0 }}
                    transition={{
                      duration: 0.45,
                      ease: "easeInOut",
                    }}
                  >
                    {item.description}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default FAQ;
